module.exports = __webpack_public_path__ + "static/media/user_icon.b044464f.jpg";